import React, { useEffect, useMemo, useState } from 'react';
import Breadcrums from '../../../components/company_panel/common/breadcrumbs';
import downArrowImg from '../../../assets/company/img/downArrow.png'
import { useFormik } from 'formik';
import * as Yup from 'yup';
import Swal from 'sweetalert2';
import { AddStationFlow, DeleteStationFlow, DetailsStation, FlowList, GetStationFlowList } from '../../../services/company_panel/routingStationService';
import { getBrandId, getCompany } from '../../../helpers/commonFunctions';
import { useNavigate, useParams } from 'react-router-dom';
import { globalLoader } from '../../../helpers/global';
import { LOADER_TIME } from '../../../utils/Constants';
import {IconTrashX} from '@tabler/icons-react';


const StationFlow = () => {
    const params = useParams();
    const navigate = useNavigate();
    const breadcrumbs = [
        {
            title: "Routing Station",
            url: "/company/menu/routing-station/groups/list/1"
        },
        {
            title: "Stations",
            url: "/company/menu/routing-station/stations/list/1"
        },
        {
            title: "Station Flow",
            url: ""
        },
    ]

    const [showDefault, setShowDefault] = useState({});
    const [stationsList, setStationsList] = useState({});
    const [stations, setStations] = useState([]);
    const [listStations, setListStations] = useState([]);
    const [selectedStationIds, setSelectedStationIds] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [newStation, setNewStation] = useState('');
    const [loader, setLoader] = useState(false);
    const [deleteLoader, setDeleteLoader] = useState(false);
    const [deletingId, setDeletingId] = useState(null);
    const [isBrandChanged, setIsBrandChanged] = useState(false);
    const [currentBrand] = useState(getBrandId());

    useMemo(()=>{
		document.addEventListener('brand-changed', function(){
			setIsBrandChanged(!isBrandChanged);
		});
        setTimeout(() => {
            if (currentBrand != getBrandId()) {
                navigate(`/company/menu/routing-station/stations/list/${1}`);
            }
        }, 100);
	});

    useEffect(() => {
        DetailsStation(params.id).then(data => {
            setShowDefault(data && data?.data && data?.data?.response ? data?.data?.response : [])
        }).catch(error => {
            console.log("error=====>", error)
        })
    }, []);


    const getStationFlow = () => {
        GetStationFlowList(params.id).then((response) => {
            // let stationsName = response.data.response;
            setStationsList(response && response.data && response.data.response ? response?.data?.response : [])
            // stationsName = stationsName.map(item => item.name)
            // setStations(stationsName)
            // let stationsIds = response.data.response.map(item => item.id)
            // setSelectedStationIds(stationsIds)
            // setListStations(response && response.data && response.data.response ? response?.data?.response : [])
        })
            .catch((error) => {
                console.log("error===>", error)
            })
    }


    function GetStationList() {
        const listFlowData = new FormData();
        listFlowData.append("brand_id", getBrandId());
        listFlowData.append("id", params.id)
        FlowList(listFlowData)
            .then((response) => {
                setListStations(response && response.data && response.data.response ? response?.data?.response : [])
            })
            .catch((error) => {
                console.log("error===>", error)
            })
    }


    useEffect(() => {
        getStationFlow();
        GetStationList();
    }, [isBrandChanged]);

    // const handleShowModal = () => setShowModal(true);
    // const handleCloseModal = () => setShowModal(false);


    const handleAddStation = (e) => {
        // if (newStation.trim()) {
        // setStations([newStation, ...stations]);
        // setNewStation('');
        // const newSelectedStationId = listStations.filter(item => item.name == newStation);
        // setSelectedStationIds([...selectedStationIds, newSelectedStationId[0].id]);
        // handleCloseModal();
        // let Id = [newSelectedStationId[0].id]
        setLoader(true);

        AddStationFlow({ stationFlows: [newStation], brand_id: getBrandId(), company_id: getCompany().id, station_id: params.id })
            .then((response) => {
                setLoader(false);
                if (response.data.status === 1 || response.data.status === "1") {
                    Swal.fire({
                        customClass: 'swal-wide',
                        icon: 'success',
                        title: response.data.message,
                        showConfirmButton: false,
                        timer: 1500,
                        toast: true,
                        position: 'top-right',
                    });
                    setNewStation(null);
                    getStationFlow();
                    GetStationList();
                    document.getElementById('closeAddCardModal').click();
                } else {
                    Swal.fire({
                        customClass: 'swal-wide',
                        icon: 'error',
                        title: response.data.message,
                        showConfirmButton: false,
                        timer: 5000,
                        toast: true,
                        position: 'top-right',
                    })
                }

            })
            .catch((error) => {
                setLoader(false);
                console.log("error===>", error)
            })
        // }
    };

    const handelDeleteStation = (station, index) => {
        // const stationData = listStations.filter(item => item.name === station)[0];

        Swal.fire({
            customClass: 'swal-wide',
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#2f9bff',
            cancelButtonColor: '#dc3545',
            confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
            if (result.isConfirmed) {
                setDeleteLoader(true);
                setDeletingId(station);
                const deleteForm = new FormData();
                deleteForm.append("station_id", params.id);
                deleteForm.append("id", station);
                DeleteStationFlow(deleteForm)
                    .then((response) => {
                        setDeleteLoader(false);
                        setDeletingId(null);
                        if (response.data.status === 1 || response.data.status === "1") {
                            getStationFlow();
                            GetStationList();
                            Swal.fire({
                                customClass: 'swal-wide',
                                icon: 'success',
                                title: response.data.message,
                                showConfirmButton: false,
                                timer: 1500,
                                toast: true,
                                position: 'top-right',
                            });
                        } else {
                            Swal.fire({
                                customClass: 'swal-wide',
                                icon: 'error',
                                title: response.data.message,
                                showConfirmButton: false,
                                timer: 5000,
                                toast: true,
                                position: 'top-right',
                            })
                        }

                    })
                    .catch((error) => {
                        setDeleteLoader(false);
                        setDeletingId(null);
                        console.log("error===>", error)
                    })
            }
        }).catch((error) => {
            console.log("Error==>", error);

        })



        // const newStations = stations.filter((_, i) => i !== index);
        // setStations(newStations);
    };

    // function handelSubmitStationFlow() {

    //     AddStationFlow({ stationFlows: selectedStationIds, brand_id: getBrandId(), company_id: getBrandId(), station_id: params.id })
    //         .then((response) => {
    //             if (response.data.status === 1 || response.data.status === "1") {
    //                 Swal.fire({
    //                     customClass: 'swal-wide',
    //                     icon: 'success',
    //                     title: response.data.message,
    //                     showConfirmButton: false,
    //                     timer: 1500,
    //                     toast: true,
    //                     position: 'top-right',
    //                 });
    //                 setTimeout(() => {
    //                     navigate(`/company/menu/routing-station/stations/list/1`)
    //                 }, 1000);
    //             } else {
    //                 Swal.fire({
    //                     customClass: 'swal-wide',
    //                     icon: 'error',
    //                     title: response.data.message,
    //                     showConfirmButton: false,
    //                     timer: 5000,
    //                     toast: true,
    //                     position: 'top-right',
    //                 })
    //             }

    //         })
    //         .catch((error) => {
    //             console.log("error===>", error)
    //         })
    // }

    return (
        <>
            <div className="page-header d-flex align-items-center">
                <div className="page-header-left">
                    <h4>Routing Station</h4>
                    <Breadcrums data={breadcrumbs} />
                </div>
                <div className="page-header-right ms-auto">
                </div>
            </div>
            <div className="card custom-card">
                <div className="card-body d-flex justify-content-center">
                    <div className="card custom-card w-50" style={{ maxWidth: '560px', border: 'none', boxShadow: '0 4px 24px rgba(15,23,42,0.06)', borderRadius: '16px' }}>
                        <div className="card-body" style={{ padding: '28px 32px' }}>
                            <div className="text-center mb-4">
                                <h2 className="mb-1" style={{ fontWeight: 700, letterSpacing: '-0.01em' }}>{showDefault?.name}</h2>
                                <p className="text-muted mb-0" style={{ fontSize: '0.85rem' }}>Station processing flow</p>
                            </div>
                            {stationsList && stationsList.length > 0 && stationsList.map((station, index) => (
                                <div key={station?.id}>
                                    <div
                                        className="d-flex align-items-center station-tab"
                                        style={{
                                            background: '#f8fafc',
                                            border: '1px solid #e8edf3',
                                            borderRadius: '12px',
                                            padding: '14px 16px',
                                        }}
                                    >
                                        <span
                                            className="d-flex align-items-center justify-content-center me-3 flex-shrink-0"
                                            style={{ width: '32px', height: '32px', borderRadius: '50%', background: '#2f9bff', color: '#fff', fontWeight: 600, fontSize: '0.9rem' }}
                                        >
                                            {index + 1}
                                        </span>
                                        <div className="flex-grow-1 fw-semibold" style={{ fontSize: '1rem' }}>{station?.name}</div>
                                        <button
                                            className={deletingId === station?.id ? `loading-button station-tab-btn` : `station-tab-btn`}
                                            onClick={() => handelDeleteStation(station?.id, index)}
                                            disabled={deleteLoader}
                                            title="Remove station"
                                            style={{ border: 'none', background: 'transparent', color: '#dc3545', padding: '6px', borderRadius: '8px' }}
                                        >
                                            {deletingId === station?.id ? <i className="fa fa-spinner fa-spin me-2"></i> : null}<IconTrashX stroke={2} size={20} />
                                        </button>
                                    </div>
                                    <div className="downArrow d-flex justify-content-center" style={{ padding: '6px 0' }}><img src={downArrowImg} /></div>
                                </div>
                            ))}
                            <div
                                className="d-flex justify-content-center align-items-center station-tab-btn cp"
                                data-bs-toggle="modal" data-bs-target="#addCardModal" href='#addCardModal'
                                style={{ border: '2px dashed #2f9bff', color: '#2f9bff', borderRadius: '12px', padding: '14px', fontWeight: 600, background: 'rgba(47,155,255,0.04)' }}
                            >
                                + Add Next Station
                            </div>
                        </div>
                    </div>

                    {/* <div className="modal d-block" tabIndex="-1"> */}
                    <div className="modal fade " id="addCardModal" aria-labelledby="addCardModalLabel" aria-hidden="true" data-bs-backdrop="static">
                        <div className="modal-dialog">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h2 className="modal-title">Next Station</h2>
                                    <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" id="closeAddCardModal" onClick={()=> setNewStation('')}></button>
                                </div>
                                <div className="modal-body">
                                    <div className="mb-3">
                                        <select
                                            className="form-control cp"
                                            name="newStation"
                                            value={newStation}
                                            onChange={(e) => setNewStation(e.target.value)}
                                        >
                                            <option value="">Select Station</option>
                                            {listStations && listStations.length > 0 && listStations.map((station) => (
                                                <option key={station?.id} value={station?.id}>
                                                    {station.name}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                    <button type="button" className="btn btn-outline-primary" style={{ width: '48%', marginRight: '10px' }}  onClick={()=> setNewStation('')} data-bs-dismiss="modal" aria-label='Close'>Cancel</button>
                                    <button type="submit" disabled={!newStation} className={loader ? `loading-button btn btn-primary` : ' btn btn-primary'} style={{ width: '48%' }} onClick={handleAddStation}>{loader ? <i className="fa fa-spinner fa-spin me-2"></i> : null}Add</button>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                <div className="button-container mb-4 pl-1 d-flex justify-content-center">
                    {/* <button className="btn btn-primary ms-2 btn-submit" type="submit" onClick={handelSubmitStationFlow}>Submit</button> */}
                    <button className="btn btn-secondary ms-2 btn-submit" type="submit" onClick={() => navigate(-1)}>Back</button>
                </div>

            </div>
        </>
    );
};

export default StationFlow;
